/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Orders_Estes_Booked_SuccessInputs */

const en_orders_estes_booked_success = /** @type {(inputs: Orders_Estes_Booked_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`LTL shipment booked for ${i?.count} order(s)`)
};

const es_orders_estes_booked_success = /** @type {(inputs: Orders_Estes_Booked_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Envio LTL reservado para ${i?.count} pedido(s)`)
};

/**
* | output |
* | --- |
* | "LTL shipment booked for {count} order(s)" |
*
* @param {Orders_Estes_Booked_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_estes_booked_success = /** @type {((inputs: Orders_Estes_Booked_SuccessInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Estes_Booked_SuccessInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_estes_booked_success(inputs)
	return es_orders_estes_booked_success(inputs)
});